export default __webpack_public_path__ + "static/media/miguel-lopes-24.d25f40ae.jpg";